<template>
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.83333 2H2.5V5.33333M11.1667 2H14.5V5.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.5 2L7.524 7.024C8.14876 7.64892 8.49981 8.49634 8.5 9.38V14M12.5 4.00667V4M11.1667 5.34667V5.34M9.83333 6.66667V6.67333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
